import React from 'react';

import Button from '../../../../library/button/button';
import { SlidersRegularIcon } from '../../../../shared/icons/icons';

import './filter-button.scss';

interface FilterButtonProps {
  className?: string;
  filterCount: number;
  onToggleMobileFilter?: () => void;
}

function FilterButton(props: FilterButtonProps) {
  const { className, filterCount, onToggleMobileFilter } = props;

  return (
    <Button
      className={className}
      isSecondary
      onClick={onToggleMobileFilter}
      styleName="filter-button"
    >
      <SlidersRegularIcon styleName="filter-button-icon" />
      filters
      {!isNaN(filterCount) && filterCount > 0 && (
        <span styleName="filter-button-count">({filterCount})</span>
      )}
    </Button>
  );
}

export default FilterButton;
